<template>
  <div>
    <div class="" :key="itemTypeKey" v-for="(itemType, itemTypeKey) in userItems">
      <h3>{{itemTypeKey}}</h3>
      <div :key="itemKey" v-for="(item, itemKey) in itemType" class="flex wrap between align-center">
        <router-link :to="`/i/${itemTypeKey}/${itemKey}`">{{item.basics.title}}</router-link>
        <rm :obj="itemType" :name="itemKey" :item="item" />
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      type: String,
      id: String
    },
    data () {
      return {
        awaitDataCounter: {},
        show: {
          manageItem: {},
          confirmDelete: {}
        },
        userItem: {},
        userItems: {}
      }
    },
    methods: {
      confirmDelete (id, bool) {
        this.$set(this.show.confirmDelete, id, bool)
      },
      deleteItem (item) {
        this.$store.state.user[this.$store.state.auth.uid].items[item.type].pop(this.$store.state.user[this.$store.state.auth.uid].items[item.type].indexOf(item.id))
        this.showItem(item.id, false)
        this.$store.dispatch('delete', item)
      },
      showItem (id, bool) {
        this.$set(this.show.manageItem, id, bool)
      }
    },
    async mounted () {
      var retObj = {}
      return Promise.all(await this.$store.state.app.itemTypes.map(async(itemType) => {
        return await this.$store.dispatch('query', {
          type: 'manage',
          collection: itemType
        }).then((d) => {
          return d ? retObj[itemType] = d : null
        })
      })).then(()=>{
        return this.$set(this, 'userItems', retObj)
      })
    }
  }
</script>